import { connect } from 'react-redux';
import { RegistrationForm } from '../../components/RegistrationForm';
import { register as _register } from '../../actions/registration';

function mapStateToProps(state) {
  return {
    registration: state.registration,
    withSubscriptionAgreement: !state.isNextAgreementFlow
  };
}

function mapDispatchToProps(dispatch) {
  return {
    register: function register(parameters) {
      return dispatch(_register(parameters));
    }
  };
}

export var RegistrationFormContainer = connect(mapStateToProps, mapDispatchToProps)(RegistrationForm);